export default __webpack_public_path__ + "media/images/landing-12-550x420-f2a3c854e235338838ce2554fb50820b.jpg";